module.exports = __webpack_public_path__ + "static/media/pg.84ce1d08.png";